import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type ToastCtxValue = { show: (message: string) => void };

const ToastCtx = createContext<ToastCtxValue>({ show: () => {} });

export const useToast = () => useContext(ToastCtx);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState('');

  const show = useCallback((msg: string) => {
    setMessage(msg);
    window.setTimeout(() => {
      setMessage((cur) => (cur === msg ? '' : cur));
    }, 2200);
  }, []);

  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      {message ? (
        <div className="toast" role="status" aria-live="polite">
          <i className="ri-heart-3-fill" aria-hidden="true" />
          <span>{message}</span>
        </div>
      ) : null}
    </ToastCtx.Provider>
  );
}

export default ToastProvider;